
import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Address } from "../../models/entity/address";
import { CustomerSearchRequest } from "../../models/rest/customer/customerSearchRequest";
import { CustomerSearchByPhoneRequest } from "../../models/rest/customer/customer-search-by-phone-request";
import { CustomerSearchResponse } from "../../models/rest/customer/customerSearchResponse";
import { CustomerDetailDto } from "../../models/dto/customerDetailDto";
import { OrderView } from "../../models/dto/orderView";
import { BaseRestService } from "../base-rest.service";
import { ReceiptLabelResponse } from "../../models/rest/setting/receiptLabelResponse";
import { CustomerMergeRequest } from "../../models/rest/customer/customer-merge-request.model";
import { CustomerBulkMergeRequest } from "../../models/rest/customer/customer-bulk-merge-request.model";
import { CustomerBulkMergeResponse } from "../../models/rest/customer/customer-bulk-merge-response.model";
import { CustomerBalanceResponse } from "../../models/rest/customer/customer-balance-response";
import { CustomerBalanceRequest } from "../../models/rest/customer/customer-balance-request";
import { CustomerModifyParentRelationRequest } from "../../models/rest/customer/customer-modify-parent-relation-request.model";
import { CustomerCampaignViewModel } from "../../models/dto/campaign/customer-campaign-view.model";
import { CustomerCreationRequest } from "../../models/rest/customer/customerCreationRequest";
import { SessionStorageService } from "../session-storage.service";
import { CustomerSearchGlobalRequest } from "../../models/rest/customer/customer-search-global-request";
import { CustomerProductAttributeFormRequest } from "../../models/rest/customer/customer-product-attribute-form-request";
import { CustomerDiscountResponse } from "../../models/rest/customer/customer-discount-response";
import { CustomerEntity } from "../../models/entity/customer/customer.entity";
import { CustomerStoreUpdateRequest } from "../../models/rest/customer/customer-store-update-request";
import { CustomerDetailRequest } from "../../models/rest/customer/customer-detail-request.model";
import { CustomerDetailResponse } from "../../models/rest/customer/customer-detail-response.model";
@Injectable({
  providedIn: "root"
})
export class CustomerService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }


  getCustomers(): Observable<CustomerEntity[]> {
    const url = `/customers`;
    return this.httpGet<CustomerEntity[]>(url).pipe(catchError(this.errorHandler));
  }

  getCustomersBySearchGlobal(request: CustomerSearchGlobalRequest): Observable<CustomerSearchResponse[]> {
    const url = `/customers/search-global`;
    return this.httpPost<CustomerSearchResponse[]>(url, request).pipe(catchError(this.errorHandler));
  }

  getFavoriteCustomers(): Observable<CustomerSearchResponse[]> {
    const url = `/customers/favorites`;
    return this.httpGet<CustomerSearchResponse[]>(url).pipe(catchError(this.errorHandler));
  }


  getCustomersBySearch(
    search: CustomerSearchRequest
  ): Observable<CustomerSearchResponse[]> {
    //
    const url = `/customers/search`;
    return this.httpPost<CustomerSearchResponse[]>(url, search)
      .pipe(catchError(this.errorHandler));
  }

  getCustomersByPhoneSearch(search: CustomerSearchByPhoneRequest): Observable<CustomerSearchResponse> {
    //
    const url = `/customers/search-by-phone`;
    return this.httpPost<CustomerSearchResponse>(url, search)
      .pipe(catchError(this.errorHandler));
  }

  getCustomerById(id): Observable<CustomerEntity> {
    const url = `/customers/${id}`;
    return this.httpGet<CustomerEntity>(url).pipe(catchError(this.errorHandler));
  }
  getCustomerDetailById(id: number): Observable<CustomerDetailDto> {
    const url = `/customers/${id}/detail`;
    return this.httpGet<CustomerDetailDto>(url).pipe(catchError(this.errorHandler));
  }

  getCustomerDetail(request: CustomerDetailRequest): Observable<CustomerDetailResponse> {
    const url = `/customers/detail`;
    return this.httpPost<CustomerDetailResponse>(url, request).pipe(catchError(this.errorHandler));
  }


  deleteCustomerById(id): Observable<CustomerEntity> {
    const url = `/customers/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }

  getCustomerOrders(search: any): Observable<OrderView[]> {
    const url = `/report/orders`;
    return this.httpPost<OrderView[]>(url, search).pipe(catchError(this.errorHandler));
  }

  updateCustomer(id, customer): Observable<CustomerEntity> {
    const url = `/customers/${id}`;
    return this.httpPut<CustomerEntity>(url, customer)
      .pipe(catchError(this.errorHandler));
  }
  updateCustomerDetail(id, customer): Observable<CustomerDetailDto> {
    const url = `/customers/${id}/detail`;
    return this.httpPut<CustomerDetailDto>(url, customer)
      .pipe(catchError(this.errorHandler));
  }
  createCustomer(data: CustomerCreationRequest): Observable<CustomerEntity> {
    //  //
    //console.log(customerCreationRequest);
    const url = `/customers/create`;
    return this.httpPost<CustomerEntity>(url, data)
      .pipe(catchError(this.errorHandler));
  }
  createCustomerV2(data: CustomerCreationRequest): Observable<CustomerEntity> {
    //  //
    //console.log(customerCreationRequest);
    const url = `/customers/create-v2`;
    return this.httpPost<CustomerEntity>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  createCustomerBySearch(data: CustomerSearchRequest): Observable<CustomerEntity> {
    //  //
    //console.log(customerCreationRequest);
    const url = `/customers/create-by-search`;
    return this.httpPost<CustomerEntity>(url, data)
      .pipe(catchError(this.errorHandler));
  }
  mergeCustomer(data: CustomerMergeRequest) {
    //  //
    //console.log(customerCreationRequest);
    const url = `/customers/merge`;
    return this.httpPost(url, data)
      .pipe(catchError(this.errorHandler));
  }

  bulkMergeCustomers(data: CustomerBulkMergeRequest): Observable<CustomerBulkMergeResponse> {
    const url = `/customers/bulk-merge`;
    return this.httpPost<CustomerBulkMergeResponse>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  modifyParentRelationForCustomer(data: CustomerModifyParentRelationRequest) {
    const url = `/customers/modify-parent-relation`;
    return this.httpPost(url, data)
      .pipe(catchError(this.errorHandler));
  }
  //Müşteri tipine göre fiyatları çek
  // getCustomerProductPriceForItemTp(
  //   storeId: number,
  //   customerTypeId: number,
  //   parentOrderItemTpId: number
  // ): Observable<ProductPriceTabDto[]> {
  //   const url = `/customers/product-prices-for-process-type?store-id=${storeId}&customer-type-id=${customerTypeId}&parent-order-item-type-id=${parentOrderItemTpId}`;
  //   return this.httpGet<ProductPriceTabDto[]>(url)
  //     .pipe(catchError(this.errorHandler));
  // }

  //Müşteri tipine göre bir ürünün fiyatlarını çek
  // getCustomerProductPriceForProduct(
  //   storeId: number,
  //   customerTypeId: number,
  //   productId: number
  // ): Observable<ProductPriceTabDto> {
  //   const url = `/customers/product-prices-for-product?store-id=${storeId}&customer-type-id=${customerTypeId}&product-id=${productId}`;
  //   return this.httpGet<ProductPriceTabDto>(url)
  //     .pipe(catchError(this.errorHandler));
  // }

  //  Müşterinin sipariş borçlarını hesaplar
  getOrderDebt(customerId: number) {
    const url = `/customers/${customerId}/order-debt`;
    return this.httpGet<number>(url).pipe(catchError(this.errorHandler));
  }

  //  Müşterinin sipariş borçlarını hesaplar
  getOrderDebtWithSubCustomer(customerId: number) {
    const url = `/customers/${customerId}/order-debt-with-sub-customer`;
    return this.httpGet<number>(url).pipe(catchError(this.errorHandler));
  }


  // Müşterinin cari bakiyesini hesaplar
  getCurrentAccountBalance(customerId: number, includeSubCustomer: boolean = false): Observable<number> {
    const url = `/customers/${customerId}/current-account-balance?include-sub-customer=${includeSubCustomer}`;
    return this.httpGet<number>(url).pipe(catchError(this.errorHandler));
  }

  getBalance(request: CustomerBalanceRequest): Observable<CustomerBalanceResponse> {
    const url = `/customers/balance`;
    return this.httpPost<CustomerBalanceResponse>(url, request).pipe(catchError(this.errorHandler));
  }

  getBonusBalance(customerId: number, includeSubCustomer: boolean = false) {
    const url = `/customers/${customerId}/bonus-balance?include-sub-customer=${includeSubCustomer}`;
    return this.httpGet<number>(url).pipe(catchError(this.errorHandler));
  }




  //Müşterinin Adresleri
  getCustomerAddresses(customerId: number): Observable<Address[]> {
    const url = `/customers/${customerId}/addresses`;
    return this.httpGet<Address[]>(url).pipe(catchError(this.errorHandler));
  }

  getCustomerContactAddress(customerId: number): Observable<Address> {
    const url = `/customers/${customerId}/contact-address`;
    return this.httpGet<Address>(url).pipe(catchError(this.errorHandler));
  }

  getCustomerBillingAddress(customerId: number): Observable<Address> {
    const url = `/customers/${customerId}/billing-address`;
    return this.httpGet<Address>(url).pipe(catchError(this.errorHandler));
  }
  //sipariş için fiş html i al
  getCustomerLabel(id: number): Observable<ReceiptLabelResponse> {
    const url = `/customers/${id}/customer-label`;
    return this.httpGet<ReceiptLabelResponse>(url)
      .pipe(catchError(this.errorHandler));
  }

  //sipariş için fiş html i al
  getCustomerProductAttributeHtml(request: CustomerProductAttributeFormRequest): Observable<ReceiptLabelResponse> {
    const url = `/customers/product-attribute-html`;
    return this.httpPost<ReceiptLabelResponse>(url, request)
      .pipe(catchError(this.errorHandler));
  }
  bulkProcess(request) {
    const url = `/customers/bulk-process`;
    return this.httpPost(url, request)
      .pipe(catchError(this.errorHandler));
  }

  getCustomerPackageCampaigns(customerId: number): Observable<CustomerCampaignViewModel[]> {
    const url = `/customers/${customerId}/package-campigns`;
    return this.httpGet<CustomerCampaignViewModel[]>(url).pipe(catchError(this.errorHandler));
  }
  getCustomerDiscounts(customerId: number): Observable<CustomerDiscountResponse[]> {
    const url = `/customers/${customerId}/customer-discounts`;
    return this.httpGet<CustomerDiscountResponse[]>(url).pipe(catchError(this.errorHandler));
  }
  updateCustomerStore(request: CustomerStoreUpdateRequest) {
    const url = `/customers/update-store`;
    return this.httpPost(url, request).pipe(catchError(this.errorHandler));
  }


  errorHandler(error: HttpErrorResponse) {
    // console.log(error);


    return observableThrowError(error);
  }
}
